<template>
  <el-dialog
      class="edit-zoho-dialog"
      title="Booking Detail"
      :visible.sync="dialogVisible"
      @close="closeModal"
      width="50%">
    <el-descriptions v-if="booking" class="margin-top" title="" :column="2"  border>
      <el-descriptions-item>
        <template slot="label">
          Booking ID
        </template>
        {{ booking.BookingID }}
      </el-descriptions-item>
      <el-descriptions-item>
        <template slot="label">
          Service Type
        </template>
        {{ booking.BookingType.BookingTypeName }}
      </el-descriptions-item>
      <el-descriptions-item>
        <template slot="label">
          Delivery Method
        </template>
        {{ booking.DeliveryMethodID === 1 ? 'In-person' : 'Virtual' }}
      </el-descriptions-item>
      <el-descriptions-item>
        <template slot="label">
          Booking Date
        </template>
        {{getDate()}}
      </el-descriptions-item>
      <el-descriptions-item>
        <template slot="label">
          Booking Status
        </template>
        {{ booking.BookingStatus ? getBookingStatusById(booking.BookingStatus) : ''}}
      </el-descriptions-item>
      <el-descriptions-item>
        <template slot="label">
          Client Name
        </template>
        {{ decodeURIComponent(booking.ClientContact.FirstName + ' ' + booking.ClientContact.Surname)}}
      </el-descriptions-item>
<!--      <el-descriptions-item>-->
<!--        <template slot="label">-->
<!--          Branch Name-->
<!--        </template>-->
<!--        {{ booking.Client.BranchName }}-->
<!--      </el-descriptions-item>-->
<!--      <el-descriptions-item>-->
<!--        <template slot="label">-->
<!--          Examinee Preferred Name-->
<!--        </template>-->
<!--        {{ booking.PreferredGivenName }}-->
<!--      </el-descriptions-item>-->
<!--      <el-descriptions-item>-->
<!--        <template slot="label">-->
<!--        Body Areas-->
<!--        </template>-->
<!--        {{ booking.FullBodyAreas }}-->
<!--      </el-descriptions-item>-->
      <el-descriptions-item>
        <template slot="label">
          Specialist Name
        </template>
        {{ getSpecialistFullNameUpper(booking.Specialist) }}
      </el-descriptions-item>
      <el-descriptions-item>
        <template slot="label">
          Location
        </template>
        {{ booking.Location ? decodeURIComponent(booking.Location.LocationName) : '' }}
      </el-descriptions-item>
    </el-descriptions>
    <span slot="footer" class="dialog-footer">
       <v-btn dark class="me-2"  @click="toDetail(booking)">View Detail</v-btn>
       <v-btn class="white-button" dark @click="dialogVisible = false; closeModal()">Close</v-btn>
    </span>
  </el-dialog>
</template>

<script>
import utilities from "@/assets/js/utilities";

export default {
  name: "BookingModal.vue",
  props: ['booking'],
  watch: {
    booking: {
      handler(value) {
        if(value) {
          this.dialogVisible = true
        }
      },
      deep: true,
    },
  },
  methods: {
    getSpecialistFullNameUpper(specialist) {
      return utilities.getSpecialistFullNameUpper(specialist)
    },
    toDetail(item) {
      this.dialogVisible = false;
      this.$router.push({path:'/admin-manage-booking', query:{id: item.BookingID}}).catch((err) => {})
    },
    closeModal() {
      this.$emit('closeModal')
    },
    getDate() {
     return this.booking.BookingDateTime ? window.moment(this.booking.BookingDateTime).format('YYYY-MM-DD'): ''
    },
    getBookingStatusById(id) {
      if (id) {
        const status = this.bookingStatuses.find((x) => x.id == id)
        if (status) {
          return status.name
        }
      }
      return ""
    },
  },
  data() {
    return {
      dialogVisible: false,
      bookingStatuses: utilities.getBookingStatuses(),
    }
  }
}
</script>

<style scoped>

</style>
